'use strict';
(function (window, document, $) {
    $(document).on('click', '.jwsdw-confirmationSelectVoucherPicker-button-unlockVoucher', function(e) {
        e.preventDefault();
        let $form = $('#jwsdw-selectVoucher-form');
        let voucherId = $(this).attr('data-voucher-id');
        let source = $(this).attr('data-ajax-source');
        $(this).spinner().start();
        _activateLoyaltyVoucher(voucherId, $form, source, $(this));
    });

    $(document).on('click', '.jwsdw-confirmationSelectVoucherPicker-button-goBack', function(e) {
        e.preventDefault();
        window.jwsdwMediator.publish('closePicker', 'confirmationSelectVoucherPicker', true);
    });

    /**
     * @description Method to activate loyalty voucher
     * @param {string} voucherId - Selected voucher ID.
     * @param {jQuery} $formElement - form element element
     * @param {String} source - ajax call source
     * @param {jQuery} $submitButton - button element
     * @returns {void}
     */
    function _activateLoyaltyVoucher(voucherId, $formElement, source, $submitButton) {
        const data = {};
        const method = $formElement.attr('method');
        const url = $formElement.attr('action');
        data.source = source;
        data.voucherId = voucherId;
        data[window.jwsdwSettings.csrfTokenName] = window.jwsdwSettings.csrfTokenValue;
        $.ajax({
            'url': url,
            'method': method,
            'data': data,
            'success': (response) => {
                activatedVoucherSuccess(response, $submitButton);
            },
            'error': (response) => {
                activatedVoucherError(response, $submitButton);
            }
        });
    }

    /**
     * @description Handler for voucher activation successful.
     * @param {Object} data - response data.
     * @param {JQuery} $button - button element
     * @returns {void}
     */
    function activatedVoucherSuccess(data, $button) {
        window.jwsdwMediator.publish(`updateVoucherSection`, data);
        window.jwsdwMediator.publish('closePicker', 'confirmationSelectVoucherPicker', true);
        window.jwsdwMediator.publish('closePicker', 'selectVoucherPicker', true);
        $button.spinner().stop();
    }

    /**
     * @description Handler for voucher activation error.
     * @param {Object} data - response data.
     * @param {JQuery} $button - button element
     * @returns {void}
     */
    function activatedVoucherError(data, $button) {
        let $errorBanner = $('.jwsdw-selectVoucherPicker-vouchers-notificationBanner');
        if (data) {
            $errorBanner.removeClass('jws-hidden');
        }
        window.jwsdwMediator.publish('closePicker', 'confirmationSelectVoucherPicker', true);
        $button.spinner().stop();
    }
}(window, document, jQuery));

